module.exports = __webpack_public_path__ + "static/media/item-16.e3edd6fd.png";